import React, { useEffect, useState } from 'react'
import {getPremiumSalesListing} from '../../api.services.js/others'
import Loader from '../../src/components/loader'


function PremiumSales() {
  const[products, setProducts] = useState('')
  const[location, setLocation] = useState('');
  const[ size, setSize]= useState('');
  const[row, setRow] = useState('20');
  const[page, setPage] = useState('1')
  const[sortby, setSortby]= useState('1')
  const[checked, setChecked] = useState('')
  const[loading, setLoading] = useState(false)
  useEffect(()=>{
  get_premium_sales_listing()
},[location,size, row,checked, sortby, page])

  const get_premium_sales_listing = async ()=>{
   
    try{
      setLoading(true)
      if(checked){
        setSortby('2')
      } else if(!checked){
        setSortby('1')
      }
      let res = await getPremiumSalesListing({
       location,
       size,
       row,
       sortby,
       page
      })

      setProducts(res.data.showPremiumSalesProducts.data)
     setLoading(false)
    }catch(err){
      setLoading(false)
    }
  }
  return (
       
      
    <div className='premium-sale-section'>
      {
        loading ? <Loader/>:
      <div className='container'>
        <div className='premium-head-row flex-class'>
          <div className='premium-title'>
            <h1>Premium Stock – Liquidation Sales</h1>
          </div>
          <div className='premium-sort-bx'>
           <div class="switch-wrap">
              <span class="current">Sort By Stocks</span> <span class="switch"><input type="checkbox"  checked= {checked} name="switch" id="switch" onChange={()=>{setChecked(!checked)}} /><label for="switch"></label></span> <span>Sort By Price</span>
            </div>
          </div>
        </div>
        <div className='location-row flex-class'>
          <div className='location-col'>
            
          <select class="location" id="select_location" value={location} onChange={(e)=>setLocation(e.target.value)}>
            <option value="">Select Location</option>
            <option value="1">Select All Location</option>
            <option value="SKD-WH-MFG">North, Central, East India</option>
            <option value="DRA-WH-MFG">West India</option>
            <option value="HSK-WH-MFG">South India</option>
            </select>
          </div>
          <div className='location-col'>
            
               <select class="location" value={size} id="select_size" onChange={(e)=>{setSize(e.target.value)}}>
              <option value="">Select Size</option>
              <option value="1">Select All Size</option> 
              <option value="600x600 mm">600x600 mm</option>
               <option value="600x1200 mm">600x1200 mm</option>
                <option value="300x600 mm">300x600 mm</option> 
                <option value="300x300 mm">300x300 mm</option>
                 <option value="300x450 mm">300x450 mm</option> 
                 <option value="1200x2400 mm">1200x2400 mm</option> 
                 <option value="800x2400 mm">800x2400 mm</option>
                  <option value="800x800 mm">800x800 mm</option>
                   <option value="800x1600 mm">800x1600 mm</option> 
                   <option value="195x1200 mm">195x1200 mm</option>
                    <option value="1200x1200 mm">1200x1200 mm</option>
                     <option value="1000x1000 mm">1000x1000 mm</option> 
                     <option value="800x1200 mm">800x1200 mm</option> 
                     <option value="400x400 mm">400x400 mm</option> 
                     <option value="395x395 mm">395x395 mm</option> 
                     <option value="295x295 mm">295x295 mm</option> 
                     <option value="250x375 mm">250x375 mm</option>
                      <option value="200x300 mm">200x300 mm</option>
                       <option value="145x600 mm">145x600 mm</option>
                        <option value="200x1200 mm">200x1200 mm</option> 
                        <option value="148x600 mm">148x600 mm</option> 
                        <option value="300x1200 mm">300x1200 mm</option>
                         <option value="1200x1800 mm">1200x1800 mm</option>
                         </select>
          </div>
        </div>
       {
        <div className='premium-product-row flex-class' dangerouslySetInnerHTML={{__html:products.replace("https://www.orientbell.com/", "https://server.orientbell.com/") }} ></div>
       }
        
        <div className='loadmore' onClick={()=>{
          let r=Number(row+20)
          //  setPage(page+1)
           setRow(r)
           }}>
          <a >Load More</a>
        </div>
      </div>
      }
    </div>
       
  )
}

export default PremiumSales


